import React from "react";
import { ActionIcon, Box, Text, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

const TOOLTIP_PROPS = {
  withArrow: true,
  multiline: true,
  w: 260,
  events: { hover: true, focus: true, touch: true },
} as const;

/**
 * A field label with a help icon whose tooltip carries the field's
 * explanation (instead of always-visible description text).
 */
export function LabelWithHelp({
  label,
  help,
}: {
  label: string;
  help: string;
}) {
  return (
    <>
      <Text span inherit>
        {label}
      </Text>
      <Tooltip label={help} {...TOOLTIP_PROPS}>
        <ActionIcon
          component="span"
          variant="transparent"
          size="xs"
          color="gray"
          ml={4}
          aria-label={`About ${label}: ${help}`}
          // Keep a click on the icon from focusing the field via its label.
          onClick={(event: React.MouseEvent) => event.preventDefault()}
          style={{ verticalAlign: "middle" }}
        >
          <IconInfoCircle size={14} />
        </ActionIcon>
      </Tooltip>
    </>
  );
}

/**
 * Shows `help` when hovering a disabled field. Disabled inputs don't fire
 * mouse events, so the tooltip targets a wrapper around the field.
 */
export function DisabledFieldHelp({
  disabled,
  help,
  children,
}: {
  disabled: boolean;
  help: string;
  children: React.ReactNode;
}) {
  return (
    <Tooltip label={help} disabled={!disabled} {...TOOLTIP_PROPS}>
      <Box>{children}</Box>
    </Tooltip>
  );
}
